function setViewportHeight() {
  let vh = window.innerHeight;
  
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setViewportHeight();

window.addEventListener('resize', setViewportHeight);


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}



class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );

    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));

    this.querySelectorAll('.menu-close-button').forEach((button) =>
      button.addEventListener('click', (event) => {
        this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      })
    );
  }


  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
    this.slideCount = this.querySelectorAll('.slideshow__slide').length;

    if (this.slideCount <= 1) {
      this.classList.add('slideshow--single-slide');
    }

    setTimeout(() => {
      this.initialize();
      this.setupSlideObserver();
    }, 10);
  }

  initialize() {
    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.updateSingleSlideClass();

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.removeEventListeners();

    this.boundLinkToSlide = this.linkToSlide.bind(this);
    this.boundSetSlideVisibility = this.setSlideVisibility.bind(this);

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link =>
      link.addEventListener('click', this.boundLinkToSlide)
    );

    this.slider.addEventListener('scroll', this.boundSetSlideVisibility);
    this.setSlideVisibility();

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.reducedMotion.addEventListener('change', () => {
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    });

    if (this.slider.getAttribute('data-autoplay') === 'true') {
      this.setAutoPlay();
    }

    this.update();
  }

  updateSingleSlideClass() {
    const slideCount = this.querySelectorAll('.slideshow__slide').length;
    this.classList.toggle('slideshow--single-slide', slideCount <= 1);
  }

  removeEventListeners() {
    if (this.sliderControlLinksArray) {
      this.sliderControlLinksArray.forEach(link => {
        if (this.boundLinkToSlide) {
          link.removeEventListener('click', this.boundLinkToSlide);
        }
      });
    }

    if (this.slider && this.boundSetSlideVisibility) {
      this.slider.removeEventListener('scroll', this.boundSetSlideVisibility);
    }

    if (this.autoplay) {
      clearInterval(this.autoplay);
      this.autoplay = null;
    }

    if (this.boundFocusInHandling) {
      this.removeEventListener('mouseover', this.boundFocusInHandling);
      this.removeEventListener('focusin', this.boundFocusInHandling);
    }

    if (this.boundFocusOutHandling) {
      this.removeEventListener('mouseleave', this.boundFocusOutHandling);
      this.removeEventListener('focusout', this.boundFocusOutHandling);
    }

    if (this.sliderAutoplayButton && this.boundAutoPlayToggle) {
      this.sliderAutoplayButton.removeEventListener('click', this.boundAutoPlayToggle);
    }

    if (this.setPositionTimeout) {
      clearTimeout(this.setPositionTimeout);
    }
  }

  setupSlideObserver() {
    this.slideObserver = new MutationObserver(() => {
      const currentSlideCount = this.querySelectorAll('.slideshow__slide').length;
      if (currentSlideCount !== this.slideCount) {
        this.slideCount = currentSlideCount;
        setTimeout(() => this.reinitialize(), 50);
      }
    });

    if (this.slider) {
      this.slideObserver.observe(this.slider, { childList: true, subtree: true });
    }
  }

  reinitialize() {
    this.resetPages();
    this.initialize();
    this.updateSingleSlideClass();
    this.currentPage = 1;
    this.slideScrollPosition = 0;
    this.setSlidePosition(this.slideScrollPosition);
  }

  static get observedAttributes() {
    return ['data-reset'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-reset' && oldValue === "true" && newValue === "false") {
      // handled by observer
    }
  }

  setAutoPlay() {
    if (this.autoplay) clearInterval(this.autoplay);

    this.autoplaySpeed = this.slider.dataset.speed ? parseInt(this.slider.dataset.speed) * 1000 : 5000;

    this.boundFocusInHandling = this.focusInHandling.bind(this);
    this.boundFocusOutHandling = this.focusOutHandling.bind(this);

    this.addEventListener('mouseover', this.boundFocusInHandling);
    this.addEventListener('mouseleave', this.boundFocusOutHandling);
    this.addEventListener('focusin', this.boundFocusInHandling);
    this.addEventListener('focusout', this.boundFocusOutHandling);

    this.sliderItems = Array.from(this.querySelectorAll('.slideshow__slide'));
    const hasMultipleSlides = this.sliderItems.length > 1;

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.boundAutoPlayToggle = this.autoPlayToggle.bind(this);
      this.sliderAutoplayButton.addEventListener('click', this.boundAutoPlayToggle);
      this.autoplayButtonIsSetToPlay = true;

      hasMultipleSlides ? this.play() : this.pause();
    } else {
      if (!this.reducedMotion.matches && hasMultipleSlides) {
        this.play();
      } else {
        this.pause();
      }
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);
    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({ left: position });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (this.prevButton) this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

    const activeIndex = Math.min(this.currentPage - 1, this.sliderControlButtons.length - 1);
    if (activeIndex >= 0) {
      const activeLink = this.sliderControlButtons[activeIndex];
      activeLink.classList.add('slider-counter__link--active');
      activeLink.setAttribute('aria-current', true);
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling() {
    if (this.sliderAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (!this.reducedMotion.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      this.sliderAutoplayButton &&
      (event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target));

    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay || (this.announcementBarSlider && this.announcementBarSlider.contains(event.target))) {
      this.pause();
    }
  }

  play() {
    if (this.sliderItemsToShow.length <= 1) return;

    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.boundAutoRotateSlides = this.autoRotateSlides.bind(this);
    this.autoplay = setInterval(this.boundAutoRotateSlides, this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
    this.autoplay = null;
  }

  togglePlayButtonState(pauseAutoplay) {
    if (!this.sliderAutoplayButton) return;

    this.sliderAutoplayButton.classList.toggle('slideshow__autoplay--paused', pauseAutoplay);
    this.sliderAutoplayButton.setAttribute(
      'aria-label',
      pauseAutoplay ? window.accessibilityStrings.playSlideshow : window.accessibilityStrings.pauseSlideshow
    );
  }

  autoRotateSlides() {
    if (!this.sliderItems || this.sliderItems.length <= 1) {
      this.pause();
      return;
    }

    const nextPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(nextPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      const isActive = index === this.currentPage - 1;

      item.setAttribute('aria-hidden', !isActive);
      item.toggleAttribute('tabindex', !isActive);
      linkElements.forEach(link => link.setAttribute('tabindex', isActive ? '0' : '-1'));
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider || this.sliderItems.length <= 1) return;

    const increment = button === 'next' ? 1 : -1;
    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % this.sliderItems.length;
    nextIndex = nextIndex === -1 ? this.sliderItems.length - 1 : nextIndex;

    const currentSlide = this.sliderItems[currentIndex];
    const nextSlide = this.sliderItems[nextIndex];

    const direction = increment > 0 ? 'next' : 'previous';
    const animationOut = `announcement-bar-slider--fade-out-${direction}`;
    const animationIn = `announcement-bar-slider--fade-in-${direction}`;

    currentSlide.classList.add(animationOut);
    nextSlide.classList.add(animationIn);

    setTimeout(() => {
      currentSlide.classList.remove(animationOut);
      nextSlide.classList.remove(animationIn);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const targetIndex = this.sliderControlLinksArray.indexOf(event.currentTarget);
    const position = this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth * (targetIndex + 1 - this.currentPage);

    this.slider.scrollTo({ left: position });
  }

  disconnectedCallback() {
    if (this.slideObserver) this.slideObserver.disconnect();
    this.removeEventListeners();
  }
}

customElements.define('slideshow-component', SlideshowComponent);



class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;
  viewObserver = undefined;
  hasTrackedRecommendationView = false;
  recommendationItems = [];
  recommendationClickHandler = undefined;
  recommendationTemplateHTML = '';
  variantChangeUnsubscriber = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.captureRecommendationTemplate();

    if (
      this.dataset.recommendationEngine === 'algolia'
      && typeof subscribe === 'function'
      && typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
    }

    this.initializeRecommendations(this.getRecommendationObjectId());
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.variantChangeUnsubscriber?.();
    this.variantChangeUnsubscriber = undefined;
    this.teardownRecommendationTracking();
  }

  captureRecommendationTemplate() {
    const template = this.querySelector('template[data-recommendation-template]');

    if (template instanceof HTMLTemplateElement) {
      this.recommendationTemplateHTML = template.innerHTML;
    }
  }

  getRecommendationObjectId() {
    return this.dataset.recommendationObjectId || this.dataset.productId || '';
  }

  handleVariantChange = ({ data } = {}) => {
    if (String(data?.productId || '') !== String(this.dataset.productId || '')) {
      return;
    }

    const nextVariantId = String(data?.variant?.id || '');
    if (!nextVariantId || nextVariantId === this.getRecommendationObjectId()) {
      return;
    }

    this.dataset.recommendationObjectId = nextVariantId;
    this.observer?.disconnect();
    this.loadRecommendations(nextVariantId);
  };

  initializeRecommendations(productId) {
    if (!productId) return;

    this.observer?.disconnect();
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    if (this.dataset.recommendationEngine === 'algolia') {
      this.loadAlgoliaRecommendations(productId);
      return;
    }

    this.loadShopifyRecommendations(productId);
  }

  loadShopifyRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        let hasContent = false;

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          hasContent = true;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }

        if (hasContent && this.isConnected) {
          this.setupRecommendationTracking();
        } else {
          this.teardownRecommendationTracking();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  async loadAlgoliaRecommendations(productId) {
    try {
      const data = await this.fetchAlgoliaRecommendations(productId);
      const hits = this.getAlgoliaRecommendationHits(data, productId);
      const hasContent = await this.renderAlgoliaRecommendations(hits);

      if (hasContent) {
        this.style.display = '';
        this.classList.add('product-recommendations--loaded');

        if (this.isConnected) {
          this.setupRecommendationTracking();
        }
      } else {
        this.style.display = 'none';
        this.teardownRecommendationTracking();
      }
    } catch (error) {
      console.error(error);
      this.style.display = 'none';
      this.teardownRecommendationTracking();
    }
  }

  getAlgoliaRecommendationsConfig() {
    const algoliaConfig = window.algoliaShopify?.config;
    const algoliaAppId = algoliaConfig?.app_id;
    const algoliaApiKey = algoliaConfig?.search_api_key;
    const currentMarket = window.poAlgoliaUtils?.getCurrentMarket?.();
    const normalizedSuffix =
      window.poAlgoliaUtils?.normalizeMarketSuffix?.(currentMarket?.suffix) || currentMarket?.suffix;
    const indexName = algoliaConfig?.index_prefix
      ? `${algoliaConfig.index_prefix}products${normalizedSuffix ? `_${normalizedSuffix}` : ''}`
      : null;

    if (!algoliaAppId || !algoliaApiKey || !indexName) {
      return null;
    }

    return {
      algoliaAppId,
      algoliaApiKey,
      indexName,
    };
  }

  async fetchAlgoliaRecommendations(productId) {
    const config = this.getAlgoliaRecommendationsConfig();
    const userToken = window.poAlgoliaInsights?.getUserToken?.();

    if (!config) {
      throw new Error('Algolia recommendations configuration is not available.');
    }

    const url = new URL(`https://${config.algoliaAppId}-dsn.algolia.net/1/indexes/*/recommendations`);
    url.searchParams.set('x-algolia-api-key', config.algoliaApiKey);
    url.searchParams.set('x-algolia-application-id', config.algoliaAppId);

    const recommendationObjectId = String(productId || '');
    const maxRecommendations = Number.parseInt(this.dataset.productsToShow || '', 10);
    const threshold = Number.parseFloat(this.dataset.recommendationThreshold || '') || 0;
    const facetFilters = [];
    const request = {
      indexName: config.indexName,
      model: this.dataset.recommendationModel || 'related-items',
      objectID: recommendationObjectId,
      threshold,
    };

    if (Number.isFinite(maxRecommendations) && maxRecommendations > 0) {
      request.maxRecommendations = maxRecommendations;
    }

    if (this.dataset.showOnlyAvailable !== 'false') {
      facetFilters.push('inventory_available:true');
    }

    facetFilters.push(`objectID:-${recommendationObjectId}`);
    request.queryParameters = {
      ...(facetFilters.length ? { facetFilters } : {}),
      clickAnalytics: true,
      ...(userToken ? { userToken } : {}),
    };

    const response = await fetch(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ requests: [request] }),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch Algolia recommendations. Status: ${response.status}`);
    }

    return response.json();
  }

  getAlgoliaRecommendationHits(data, recommendationObjectId) {
    const results = Array.isArray(data?.results) ? data.results : [];
    const fallbackIndexName = this.getAlgoliaRecommendationsConfig()?.indexName || '';
    const rawHits = results.flatMap((result) => {
      const hits = Array.isArray(result?.hits) ? result.hits : [];
      const queryID = String(result?.queryID || '').trim();
      const indexName = String(result?.index || result?.indexName || fallbackIndexName).trim();

      return hits.map((hit, index) => ({
        ...hit,
        __queryID: queryID,
        __indexName: indexName,
        __position: index + 1,
      }));
    });
    const seenHandles = new Set();
    const currentProductId = String(recommendationObjectId || '');
    const currentHandle = this.getHandleFromUrl(window.location.pathname);
    const maxRecommendations = Number.parseInt(this.dataset.productsToShow || '', 10);

    const hits = rawHits.filter((hit) => {
      const handle = hit?.handle;

      if (!handle || seenHandles.has(handle)) return false;
      if (String(hit?.objectID || '') === currentProductId) return false;
      if (handle === currentHandle) return false;
      if (this.dataset.showOnlyAvailable === 'true' && hit?.inventory_available === false) return false;

      seenHandles.add(handle);
      return true;
    });

    if (Number.isFinite(maxRecommendations) && maxRecommendations > 0) {
      return hits.slice(0, maxRecommendations);
    }

    return hits;
  }

  async renderAlgoliaRecommendations(hits = []) {
    if (!this.recommendationTemplateHTML || hits.length === 0) {
      return false;
    }

    const template = document.createElement('template');
    template.innerHTML = this.recommendationTemplateHTML;
    const content = template.content.cloneNode(true);
    const slidesContainer = content.querySelector('[data-recommendation-slides]');

    if (!slidesContainer) {
      return false;
    }

    const slideResults = await Promise.allSettled(
      hits.map((hit, index) => this.fetchAlgoliaRecommendationCardSlide(hit, index + 1))
    );

    const slides = slideResults.flatMap((result) =>
      result.status === 'fulfilled' && result.value ? [result.value] : []
    );

    if (!slides.length) {
      return false;
    }

    slides.forEach((slide) => slidesContainer.appendChild(slide));

    this.innerHTML = '';
    this.appendChild(content);

    requestAnimationFrame(() => {
      this.querySelector('swiper-slider')?.refreshSwiper?.();
    });

    return true;
  }

  async fetchAlgoliaRecommendationCardSlide(hit, position = 1) {
    const handle = hit?.handle;
    const viewName = this.dataset.productCardView || 'po-product-card';
    const cardRootSelector = this.dataset.productCardSelector || '#po-collection-product-card';
    const shopRoot = window.Shopify?.routes?.root || '/';

    if (!handle) {
      return null;
    }

    const productUrl = new URL(`${shopRoot}products/${encodeURIComponent(handle)}`, window.location.origin);
    productUrl.searchParams.set('view', viewName);

    if (this.dataset.productCardShowVariant) {
      productUrl.searchParams.set('show_variant', this.dataset.productCardShowVariant);
    }

    const response = await fetch(productUrl.toString());

    if (!response.ok) {
      throw new Error(`Failed to fetch recommendation card for ${handle}. Status: ${response.status}`);
    }

    const text = await response.text();
    const html = document.createElement('div');
    html.innerHTML = text;

    const cardRoot = html.querySelector(cardRootSelector);
    const cardContent = cardRoot?.firstElementChild || html.firstElementChild;

    if (!cardContent) {
      return null;
    }

    const cardSlot = document.createElement('div');
    cardSlot.className = 'po-card-fetch-slot';
    cardSlot.dataset.cardFetchState = 'loaded';
    cardSlot.dataset.cardVirtualized = 'false';
    cardSlot.appendChild(cardContent);

    const slide = document.createElement('div');
    slide.className = ['swiper-slide', 'tw-px-0', this.dataset.slideClass || ''].filter(Boolean).join(' ');
    slide.appendChild(cardSlot);

    if (typeof window.poAlgoliaInsights?.annotateElement === 'function') {
      const algoliaItem = {
        objectID: String(hit?.objectID || ''),
        queryID: String(hit?.__queryID || ''),
        indexName: String(hit?.__indexName || ''),
        handle,
        position: position || hit?.__position || 1,
        source: this.getRecommendationSource(),
      };
      const targets = [
        slide,
        cardSlot,
        cardContent,
        ...slide.querySelectorAll(
          'a[href*="/products/"], product-form, .po-algolia-product-card, .card-product--info, [type="submit"], .js-add-to-cart'
        ),
      ];

      targets.forEach((target) => window.poAlgoliaInsights.annotateElement(target, algoliaItem));
    }

    return slide;
  }

  teardownRecommendationTracking() {
    this.viewObserver?.disconnect();
    this.viewObserver = undefined;
    this.hasTrackedRecommendationView = false;
    this.recommendationItems = [];

    if (this.recommendationClickHandler) {
      this.removeEventListener('click', this.recommendationClickHandler, true);
      this.recommendationClickHandler = undefined;
    }
  }

  setupRecommendationTracking() {
    this.teardownRecommendationTracking();
    this.recommendationItems = this.collectRecommendationItems();

    if (!this.recommendationItems.length) return;

    this.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      if (!link.getAttribute('data-element-id')) {
        link.setAttribute('data-element-id', 'Recommendation_Carousel_Click');
      }

      if (!link.getAttribute('data-description')) {
        const href = link.getAttribute('href') || '';
        const handle = this.getHandleFromUrl(href);
        link.setAttribute('data-description', handle || href);
      }
    });

    this.recommendationClickHandler = (event) => {
      const link = event.target?.closest('a[href]');
      if (!link || !this.contains(link)) return;

      const href = link.getAttribute('href');
      if (!href || !href.includes('/products/')) return;

      const url = new URL(href, window.location.origin).toString();
      const handle = this.getHandleFromUrl(url);
      const trackedItem = typeof window.poAlgoliaInsights?.getItemFromElement === 'function'
        ? window.poAlgoliaInsights.getItemFromElement(link, {
            handle,
            url,
            source: this.getRecommendationSource(),
          })
        : {
            handle,
            url,
            source: this.getRecommendationSource(),
          };
      const item = this.recommendationItems.find((entry) => {
        return (
          (entry.objectID && entry.objectID === trackedItem.objectID)
          || (entry.handle && entry.handle === handle)
          || entry.url === url
        );
      }) || {
        ...trackedItem,
        handle,
        url,
        position: '',
      };

      this.trackRecommendationClick(item);
    };

    this.addEventListener('click', this.recommendationClickHandler, true);

    if (typeof IntersectionObserver !== 'function') {
      this.trackRecommendationView();
      return;
    }

    this.viewObserver = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        this.trackRecommendationView();
      },
      { threshold: 0.2 }
    );

    this.viewObserver.observe(this);

    window.requestAnimationFrame(() => {
      if (this.isRecommendationVisible()) {
        this.trackRecommendationView();
      }
    });
  }

  collectRecommendationItems() {
    const links = Array.from(this.querySelectorAll('a[href]'));
    const seenKeys = new Set();
    const items = [];

    links.forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || !href.includes('/products/')) return;

      const url = new URL(href, window.location.origin).toString();
      const handle = this.getHandleFromUrl(url);
      const trackedItem = typeof window.poAlgoliaInsights?.getItemFromElement === 'function'
        ? window.poAlgoliaInsights.getItemFromElement(link, {
            handle,
            url,
            position: items.length + 1,
            source: this.getRecommendationSource(),
          })
        : {
            handle,
            url,
            position: items.length + 1,
            source: this.getRecommendationSource(),
          };
      const key = trackedItem.objectID || handle || url;

      if (seenKeys.has(key)) return;
      seenKeys.add(key);

      items.push({
        ...trackedItem,
        el: link,
        url,
        handle,
        position: trackedItem.position || items.length + 1,
      });
    });

    return items;
  }

  getHandleFromUrl(url) {
    try {
      const parsedUrl = new URL(url, window.location.origin);
      const match = parsedUrl.pathname.match(/\/products\/([^/?#]+)/);
      return match?.[1] || '';
    } catch (_error) {
      return '';
    }
  }

  isRecommendationVisible() {
    if (!this.isConnected) return false;

    const style = window.getComputedStyle(this);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    const rect = this.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < viewportHeight &&
      rect.left < viewportWidth
    );
  }

  getRecommendationSource() {
    return this.classList.contains('complementary-products') ? 'complementary' : 'related';
  }

  trackRecommendationView() {
    if (this.hasTrackedRecommendationView || !this.recommendationItems.length) return;

    this.hasTrackedRecommendationView = true;
    const detail = {
      source: this.getRecommendationSource(),
      sectionId: this.dataset.sectionId || '',
      productId: this.dataset.productId || '',
      items: this.recommendationItems.map(({ handle, url, position, objectID, queryID, indexName }) => ({
        handle,
        url,
        position,
        objectID,
        queryID,
        indexName,
      })),
    };

    document.dispatchEvent(new CustomEvent('po:recommendations:view', { detail }));

    if (typeof window.poAlgoliaInsights?.trackViewedItems === 'function') {
      window.poAlgoliaInsights.trackViewedItems({
        source: detail.source,
        items: this.recommendationItems,
      });
    }

    if (typeof window.tealium_data2track?.push === 'function') {
      window.tealium_data2track.push({
        id: 'Event',
        Events_RecommendationView: '1',
        Recommendation_Type: detail.source,
        Recommendation_SourceProductId: detail.productId,
        Recommendation_Items: detail.items.map((item) => item.handle || item.url).join('|'),
      });
    }
  }

  trackRecommendationClick(item) {
    const detail = {
      source: this.getRecommendationSource(),
      sectionId: this.dataset.sectionId || '',
      productId: this.dataset.productId || '',
      item,
    };

    document.dispatchEvent(new CustomEvent('po:recommendations:click', { detail }));

    if (typeof window.poAlgoliaInsights?.trackClickedItem === 'function') {
      window.poAlgoliaInsights.trackClickedItem({
        source: detail.source,
        item,
      });
    }

    if (typeof window.tealium_data2track?.push === 'function') {
      window.tealium_data2track.push({
        id: 'Click',
        data_element_id: 'Recommendation_Carousel_Click',
        data_description: `${detail.source}_${item.handle || item.url}`,
        Recommendation_Position: String(item.position),
      });
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

class StickyBase extends HTMLElement {
  constructor(stickyClassName, elementName) {
    super();
    this.prevScrollPos = window.pageYOffset;
    this.stickyClassName = stickyClassName;
    this.elementName = document.querySelector(elementName).closest('.shopify-section');
    this.hiddenClass = stickyDefinitions[elementName].hidden_class;
    this.addClass = stickyDefinitions[elementName].add_class;
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    
    if (this.addClass) {
      const classes = this.addClass.split(' ');
      classes.forEach(className => {
        this.elementName.classList.add(className);
      });
      if(this.tagName == 'STICKY-ANNOUNCEMENT') {
        this.setRightHeight()
      }
    }
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  setRightHeight() {
    document.documentElement.style.setProperty('--announcement-height', this.clientHeight + 'px');
  }

  handleScroll() {
    const currentScrollPos = window.pageYOffset;
    if (currentScrollPos === 0) {
      this.elementName.classList.remove(this.hiddenClass);
    } else if (this.prevScrollPos < currentScrollPos) {
      this.elementName.classList.add(this.hiddenClass);
    } else {
      this.elementName.classList.remove(this.hiddenClass);
    }

    this.prevScrollPos = currentScrollPos;
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

function createStickyElement(className, elementName) {
  return class extends StickyBase {
    constructor() {
      super(className, elementName);
    }
  };
}

const stickyDefinitions = {
  "sticky-announcement": {
    hidden_class: "shopify-section-announcement-hidden",
    add_class: "scrolled-past-header shopify-section-announcement-sticky animate",
  },
  
  "sticky-header": {
    hidden_class: "shopify-section-header-hidden",
    add_class: "scrolled-past-header shopify-section-header-sticky animate",
  }
};

Object.entries(stickyDefinitions).forEach(([elementName, classInfo]) => {
  customElements.define(elementName, createStickyElement(classInfo, elementName));
});

class CustomScrollBar extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.content = null;
    this.scrollThumb = null;
    this.scrollTrack = null;
    this.isDragging = false;
    this.startY = 0;
    this.startScrollTop = 0;
  }

  connectedCallback() {
    this.container = this.querySelector('[custom-scrollbar="container"]');
    this.content = this.querySelector('[custom-scrollbar="content"]');
    this.scrollThumb = this.querySelector('.scroll-thumb');
    this.scrollTrack = this.querySelector('.scroll-track');

    this.container.addEventListener('scroll', this.updateThumb);
    window.addEventListener('resize', this.updateThumb);
    this.scrollThumb.addEventListener('mousedown', this.onThumbMouseDown);
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseUp);
    this.scrollTrack.addEventListener('click', this.onTrackClick);

    setTimeout(this.updateThumb, 50);
  }

  updateThumb = () => {
    const containerHeight = this.container.clientHeight;
    const contentHeight = this.content.scrollHeight;
  
    // Se content è vuoto o non ha dimensione, forziamo una dimensione minima
    if (contentHeight === 0) {
      this.content.style.minHeight = '100px';
      this.content.style.minWidth = '100%';
      return;
    }
  
    if (contentHeight <= containerHeight) {
      this.scrollThumb.style.display = 'none';
      return;
    }
  
    const thumbHeight = Math.max((containerHeight / contentHeight) * containerHeight, 30);
    const maxScroll = contentHeight - containerHeight;
    const maxThumbTravel = containerHeight - thumbHeight;
    const thumbPosition = (this.container.scrollTop / maxScroll) * maxThumbTravel;
  
    this.scrollThumb.style.display = 'block';
    this.scrollThumb.style.height = `${thumbHeight}px`;
    this.scrollThumb.style.top = `${thumbPosition}px`;
  };
  
  onThumbMouseDown = (event) => {
    this.isDragging = true;
    this.startY = event.clientY;
    this.startScrollTop = this.container.scrollTop;
    document.body.style.userSelect = 'none';
  };

  onMouseMove = (event) => {
    if (!this.isDragging) return;

    const deltaY = event.clientY - this.startY;
    const thumbHeight = parseFloat(this.scrollThumb.style.height) || 30;
    const maxThumbTravel = this.container.clientHeight - thumbHeight;
    const maxContentScroll = this.content.scrollHeight - this.container.clientHeight;
    const scrollRatio = maxContentScroll / maxThumbTravel;

    this.container.scrollTop = Math.max(0, Math.min(this.startScrollTop + deltaY * scrollRatio, maxContentScroll));
  };

  onMouseUp = () => {
    this.isDragging = false;
    document.body.style.userSelect = '';
  };

  onTrackClick = (event) => {
    if (event.target === this.scrollThumb) return;

    const trackRect = this.scrollTrack.getBoundingClientRect();
    const clickY = event.clientY - trackRect.top;
    const thumbHeight = parseFloat(this.scrollThumb.style.height) || 30;
    const maxThumbTravel = this.container.clientHeight - thumbHeight;
    const maxContentScroll = this.content.scrollHeight - this.container.clientHeight;

    const clickRatio = (clickY - thumbHeight / 2) / maxThumbTravel;
    const newScrollTop = clickRatio * maxContentScroll;

    this.container.scrollTop = Math.max(0, Math.min(newScrollTop, maxContentScroll));
  };
}

customElements.define('custom-scrollbar', CustomScrollBar);

class POStickyStrip extends HTMLElement {
  constructor() {
    super();
    this.triggerPoint = 0;
    this.hideTransitionDuration = 400;
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.enableSticky = this.dataset.sticky === 'true';

    // Check if content-scheduling has is-sticky attribute
    const contentScheduling = document.querySelector('content-scheduling[is-sticky]');
    this.hasContentScheduling = !!contentScheduling;

    if (!this.enableSticky) return;

    this.closeBtn = this.querySelector('[data-close]');

    this.bindEvents();
    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  bindEvents() {
    // Handle close button click
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const sectionContainer = this.closest('.shopify-section');
        if (sectionContainer) sectionContainer.classList.remove('is-visible');

        window.removeEventListener('scroll', this.handleScroll);

        // Reset CSS variable on close
        if (this.hasContentScheduling) {
          document.documentElement.style.setProperty('--content-scheduling-height', '0px');
        }

        window.setTimeout(() => {
          this.remove();
        }, this.hideTransitionDuration);
      });
    }

    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    const sectionContainer = this.closest('.shopify-section');

    if (scrollY > this.triggerPoint) {
      // Strip is visible — show section and update CSS variable
      if (sectionContainer) sectionContainer.classList.add('is-visible');

      if (this.hasContentScheduling) {
        document.documentElement.style.setProperty(
          '--content-scheduling-height',
          this.offsetHeight + 'px'
        );
      }

    } else {
      // Strip is hidden — hide section and reset CSS variable
      if (sectionContainer) sectionContainer.classList.remove('is-visible');

      if (this.hasContentScheduling) {
        document.documentElement.style.setProperty('--content-scheduling-height', '0px');
      }
    }
  }
}

customElements.define('po-strip-newsletter', POStickyStrip);
